import { render, staticRenderFns } from "./formDetailProcess.vue?vue&type=template&id=487b810a&"
import script from "./formDetailProcess.vue?vue&type=script&lang=js&"
export * from "./formDetailProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports